// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { createElement,forwardRef, Ref } from 'react';
import { IconBase, IconProps } from '../icon';

const element = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12 0.856079L22 6.41163V9.00004H2V6.41163L12 0.856079ZM2 21H22V23H2V21Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M7 19H5V11H7V19Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 19H11V11H13V19Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M19 19H17V11H19V19Z"}}]};

const InstitutionFilledIcon = forwardRef<SVGElement, IconProps>((props: IconProps, ref: Ref<SVGElement>) => createElement(
  IconBase,
  {
    ...props,
    id: 'institution-filled',
    ref,
    icon: element,
  },
));

InstitutionFilledIcon.displayName = 'InstitutionFilledIcon';

export default InstitutionFilledIcon;
